(() => {
  if (customElements.get('blog-filters')) return;
  class BlogFilters extends HTMLElement {
    constructor() {
      super();
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.nav = null;
      this.activeLink = null;
    }

    connectedCallback() {
      this.cacheElements();
      this.scrollToActiveLink();

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.onSectionLoad);
      }
    }

    disconnectedCallback() {
      if (window.Shopify && window.Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
      }
    }

    onSectionLoad(event) {
      if (!event.target || !event.target.contains(this)) return;
      this.cacheElements();
      this.scrollToActiveLink();
    }

    cacheElements() {
      this.nav = this.querySelector('[data-blog-filters-nav]');
      this.activeLink = this.querySelector('[data-blog-filter-active="true"]');
    }

    scrollToActiveLink() {
      if (!this.nav || !this.activeLink) return;
      requestAnimationFrame(() => {
        const navRect = this.nav.getBoundingClientRect();
        const activeRect = this.activeLink.getBoundingClientRect();
        const targetLeft = this.nav.scrollLeft + (activeRect.left - navRect.left) - (navRect.width - activeRect.width) / 2;
        this.nav.scrollTo({
          left: Math.max(0, targetLeft),
          behavior: 'smooth',
        });
      });
    }
  }
  customElements.define('blog-filters', BlogFilters);
})();
